export * from './interface';
export * from './view';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/view/index.js
// module id = 279
// module chunks = 0